const fundCategories = {
  'Miscellaneous Equity Other': 'Outros Títulos de Renda Variável Diversos',
  'United States Fixed Income': 'Renda Fixa dos Estados Unidos',
  'Greater China Equity': 'Ações da Grande China',
  'Currency Alternative': 'Alternativa de Moeda',
  'Global Large Cap Blend Equity': 'Ações Globais de Grandes Empresas Mistas',
  'Long-Short Strategy Alternative': 'Estratégia Long-Short Alternativa',
  'United States Municipal California Tax Preferred':
    'Títulos Municipais da Califórnia com Benefício Fiscal nos EUA',
  'Aggressive Allocation': 'Alocação Agressiva',
  'Moderate Allocation': 'Alocação Moderada',
  'Global Large Cap Growth Equity': 'Ações Globais de Grandes Empresas em Crescimento',
  'Market Neutral Strategy Alternative': 'Estratégia Neutra de Mercado Alternativa',
  'Other Fixed Income': 'Outras Rendas Fixas',
  'United States Equity': 'Ações dos Estados Unidos',
  'Natural Resources Sector Equity': 'Ações do Setor de Recursos Naturais',
  'Latin America Equity': 'Ações da América Latina',
  Miscellaneous: 'Diversos',
  'Precious Metals Commodities': 'Commodities de Metais Preciosos',
  'Long Term High Quality Fixed Income': 'Renda Fixa de Alta Qualidade de Longo Prazo',
  'Global Small Cap Equity': 'Ações Globais de Pequenas Empresas',
  'United States Large Cap Blend Equity': 'Ações Mistas de Grandes Empresas dos EUA',
  'Global Emerging Markets Equity': 'Ações - Mercados Emergentes',
  'United States Small Cap Equity': 'Ações de Pequenas Empresas dos EUA',
  'Health Care Equity': 'Ações do Setor de Saúde',
  'Israel Equity': 'Ações de Israel',
  'Financials Equity': 'Ações do Setor Financeiro',
  'Global Large Cap Value Equity': 'Ações Globais de Grandes Empresas de Valor',
  'Short Term Government Bond': 'Título do Governo de Curto Prazo',
  'Basic Materials Equity': 'Ações de Materiais Básicos',
  'Ultra Short Term Bond': 'Título de Prazo Ultra Curto',
  'Emerging Markets Equity': 'Ações de Mercados Emergentes',
  'Short Term High Quality Fixed Income': 'Renda Fixa de Alta Qualidade de Curto Prazo',
  'Consumer Defensive Equity': 'Ações de Consumo Defensivo',
  'Industrials Equity': 'Ações do Setor Industrial',
  'Tactical Allocation': 'Alocação Tática',
  'Trading Tools': 'Ferramentas de Negociação',
  'United States Large Cap Value Equity': 'Ações de Grandes Empresas de Valor dos EUA',
  'Europe Small Mid Cap Equity': 'Ações de Pequenas e Médias Empresas da Europa',
  'United States Money Market': 'Mercado Monetário dos EUA',
  'Consumer Cyclical Equity': 'Ações de Consumo Cíclico',
  'Europe Equity': 'Ações da Europa',
  'Utilities Equity': 'Ações do Setor de Utilidades',
  'Global Small Mid Cap Equity': 'Ações Globais de Pequenas e Médias Empresas',
  'United States Mid Cap Equity': 'Ações de Empresas Médias dos EUA',
  'United States Large Cap Growth Equity': 'Ações de Grandes Empresas em Crescimento dos EUA',
  'Communication Services Equity': 'Ações de Serviços de Comunicação',
  Convertibles: 'Conversíveis',
  'Other Commodities': 'Outras Commodities',
  'Japan Equity': 'Ações do Japão',
  'Global Emerging Markets Fixed Income': 'Renda Fixa de Mercados Emergentes Globais',
  'Intermediate Term High Quality Fixed Income':
    'Renda Fixa de Alta Qualidade de Prazo Intermediário',
  Allocation: 'Alocação',
  'Global Equity': 'Ações Globais',
  'Long Term Low Quality Fixed Income': 'Renda Fixa de Baixa Qualidade de Longo Prazo',
  'All Cap Blend Equity': 'Ações Mistas de Todas as Capitalizações',
  'Canada Fixed Income': 'Renda Fixa do Canadá',
  'Technology Equity': 'Ações de Tecnologia',
  'United States Municipal Fixed Income': 'Renda Fixa Municipal dos EUA',
  'Energy Equity': 'Ações do Setor de Energia',
  'India Equity': 'Ações da Índia',
  'Europe Large Cap Blend Equity': 'Ações Mistas de Grandes Empresas da Europa',
  'Real Estate Equity': 'Ações do Setor Imobiliário',
  'Cautious Allocation': 'Alocação Cautelosa',
  'Asia ex-Japan Equity': 'Ações - Mercados Emergentes',
  'Asia Equity': 'Ações da Ásia',
  'Multi Alternative': 'Multi Alternativa',
  'Global Fixed Income': 'Renda Fixa Global',
  'Target Date Allocation': 'Alocação por Data Alvo',
  'China Equity - A Shares': 'Ações- China',
  'Europe ex-UK Equity': 'Ações - Europa (excluindo Reino Unido)',
  'Event Driven': 'Alternativos Liquidos',
  'Global Emerging Markets Bond': 'Renda Fixa - Mercados Emergentes',
  'Global Emerging Markets Corporate Bond': 'Renda Fixa - Mercados Emergentes',
  'Global Flexible Bond': 'Renda Fixa - Fundos de Rendimento',
  'Global Flexible Bond - USD Hedged': 'Renda Fixa - Global',
  'Global Large-Cap Blend Equity': 'Ações - Global',
  'Global Large-Cap Growth Equity': 'Ações - Globais',
  'Global Large-Cap Value Equity': 'Ações - Global',
  'Macro Trading USD': 'Alternativos Liquidos',
  'Options Trading': 'Ações - Estados Unidos',
  'Other Equity': 'Renda variavel – Regiões/Temáticos',
  'Property - Indirect Global': 'Imóveis',
  'Sector Equity Alternative Energy': 'Ações - Temáticos',
  'Sector Equity Healthcare': 'Ações - Temáticos',
  'Sector Equity Technology': 'Ações - Temáticos',
  'US Large-Cap Blend Equity': 'Ações - Estados Unidos',
  'US Large-Cap Growth Equity': 'Ações - Estados Unidos',
  'US Large-Cap Value Equity': 'Ações - Estados Unidos',
  'USD Aggressive Allocation': 'Fundo de Alocação',
  'USD Cautious Allocation': 'Fundo de Alocação',
  'USD Corporate Bond': 'Renda fixa - Grau de Investimento',
  'USD Corporate Bond - Short Term': 'Liquidez / Curto Prazo',
  'USD Diversified Bond': 'Renda fixa - Grau de Investimento',
  'USD Flexible Bond': 'Renda Fixa Flexivel',
  'USD High Yield Bond': 'Renda Fixa - Alto Rendimento',
  'USD Moderate Allocation': 'Fundo de Alocação',
  'USD Money Market': 'Liquidez / Curto Prazo',
  'USD Ultra Short-Term Bond': 'Liquidez / Curto Prazo',
};

const investmentStyles = {
  'Municipal California': 'Municipal da Califórnia',
  'Multi Alternative': 'Multi Alternativa',
  'Trading-Leveraged Commodities': 'Negociação de Commodities Alavancadas',
  'Volatility/ Derivative Strategy': 'Estratégia de Volatilidade/Derivativos',
  'Municipal New Jersey': 'Municipal de Nova Jersey',
  'Municipal Arizona': 'Municipal do Arizona',
  'Short Term Diversified Sectorial Bond': 'Título Setorial Diversificado de Curto Prazo',
  'High Yield Emerging Markets Bond': 'Título de Alto Rendimento de Mercados Emergentes',
  'Ultrashort Term Bond': 'Título de Prazo Ultracurto',
  'Municipal Oregon': 'Municipal do Oregon',
  'Municipal Nebraska': 'Municipal de Nebraska',
  'Short Term Municipal Bond': 'Título Municipal de Curto Prazo',
  'Investment Grade Bond': 'Título de Grau de Investimento',
  'Market Neutral Strategy': 'Estratégia Neutra de Mercado',
  'Short Term Mid Quality': 'Curto Prazo de Qualidade Média',
  'Municipal New York': 'Municipal de Nova York',
  'Intermediate Term Mid Quality': 'Prazo Intermediário de Qualidade Média',
  'Ultra short- Low risk': 'Ultracurto - Baixo Risco',
  'High Yield Diversified Sectoral Bond': 'Título Setorial Diversificado de Alto Rendimento',
  'Short Term High Quality': 'Curto Prazo de Alta Qualidade',
  'Municipal Wisconsin': 'Municipal de Wisconsin',
  'Municipal Virginia': 'Municipal da Virgínia',
  'Large Cap Blend': 'Mistura de Grandes Empresas',
  'Inflation Protection': 'Proteção contra Inflação',
  Miscellaneous: 'Diversos',
  'Municipal Michigan': 'Municipal de Michigan',
  'Trading-Inverse Debt': 'Negociação de Dívida Inversa',
  'Municipal North Carolina': 'Municipal da Carolina do Norte',
  'Short Term Emerging Markets Bond': 'Título de Curto Prazo de Mercados Emergentes',
  'Long-Short Strategy': 'Estratégia Long-Short',
  'Municipal South Carolina': 'Municipal da Carolina do Sul',
  'Short Term Low Quality': 'Curto Prazo de Baixa Qualidade',
  'Large Cap Growth': 'Crescimento de Grandes Empresas',
  'Ultrashort Term Government Bond': 'Título do Governo de Prazo Ultracurto',
  'Municipal Pennsylvania': 'Municipal da Pensilvânia',
  'Municipal Colorado': 'Municipal do Colorado',
  'Small Cap Growth': 'Crescimento de Pequenas Empresas',
  'Trading-Inverse Commodities': 'Negociação de Commodities Inversas',
  'Municipal Ohio': 'Municipal de Ohio',
  'Municipal Bond': 'Título Municipal',
  'Global Diversified Sectoral Bond': 'Título Setorial Diversificado Global',
  'Intermediate Term Low Quality': 'Prazo Intermediário de Baixa Qualidade',
  'Municipal Kentucky': 'Municipal de Kentucky',
  'High Yield Bond': 'Título de Alto Rendimento',
  'Municipal Georgia': 'Municipal da Geórgia',
  'Short Term Bond': 'Título de Curto Prazo',
  'Short Term Government Bond': 'Título do Governo de Curto Prazo',
  'Municipal Minnesota': 'Municipal de Minnesota',
  'Preferred Stock': 'Ações Preferenciais',
  'Equity-oriented Balanced': 'Equilibrado Orientado para Ações',
  'Leverage Strategy': 'Estratégia de Alavancagem',
  'Allocation/Balanced': 'Alocação/Equilibrado',
  'Diversified Sectoral Bond': 'Título Setorial Diversificado',
  'Municipal Hawaii': 'Municipal do Havaí',
  'Intermediate Term Bond': 'Título de Prazo Intermediário',
  'Option Writing': 'Escrita de Opções',
  'Small Cap Blend': 'Mistura de Pequenas Empresas',
  'Short Term Inflation Protection': 'Proteção contra Inflação de Curto Prazo',
  'Municipal Montana': 'Municipal de Montana',
  'Long Term High Yield Bond': 'Título de Alto Rendimento de Longo Prazo',
  'Long Term Municipal Bond': 'Título Municipal de Longo Prazo',
  'Intermediate Term Municipal Bond': 'Título Municipal de Prazo Intermediário',
  'Long Term Inflation Protection': 'Proteção contra Inflação de Longo Prazo',
  'Intermediate Term High Quality': 'Prazo Intermediário de Alta Qualidade',
  'Municipal Oklahoma': 'Municipal de Oklahoma',
  'Long Term High Quality': 'Longo Prazo de Alta Qualidade',
  'Tactical Allocation': 'Alocação Tática',
  'Bank Loan': 'Empréstimo Bancário',
  'Municipal Tennessee': 'Municipal do Tennessee',
  'Trading-Leveraged Equity': 'Negociação de Ações Alavancadas',
  'All Cap Blend': 'Mistura de Todas as Capitalizações',
  Gold: 'Ouro',
  'Short Term High Yield Bond': 'Título de Alto Rendimento de Curto Prazo',
  'Long Term Government Bond': 'Título do Governo de Longo Prazo',
  'Global High Yield Bond': 'Título de Alto Rendimento Global',
  'Managed Futures': 'Futuros Gerenciados',
  'Long Term Mid Quality': 'Longo Prazo de Qualidade Média',
  Commodities: 'Commodities',
  'Municipal North Dakota': 'Municipal de Dakota do Norte',
  'Trading-Inverse Equity': 'Negociação de Ações Inversas',
  'Municipal Maryland': 'Municipal de Maryland',
  'Municipal Kansas': 'Municipal do Kansas',
  'Trading-Leveraged Debt': 'Negociação de Dívida Alavancada',
  'Debt-oriented balanced': 'Equilibrado Orientado para Dívidas',
  'Municipal Missouri': 'Municipal do Missouri',
  'Mid Cap Growth': 'Crescimento de Empresas Médias',
  'Municipal Louisiana': 'Municipal da Louisiana',
  'Emerging Markets Diversified Sectoral Bond':
    'Título Setorial Diversificado de Mercados Emergentes',
  'Bear Market Strategy': 'Estratégia de Mercado em Baixa',
  'Municipal Mississippi': 'Municipal do Mississippi',
  Multicurrency: 'Multimoeda',
  'Municipal New Mexico': 'Municipal do Novo México',
  'Municipal Maine': 'Municipal do Maine',
  'Municipal Arkansas': 'Municipal do Arkansas',
  'Trading-Leveraged Miscellaneous': 'Negociação Diversificada Alavancada',
  'Mid Cap Value': 'Valor de Empresas Médias',
  Convertibles: 'Conversíveis',
  'Long Term Bond': 'Título de Longo Prazo',
  'Mid Cap Blend': 'Mistura de Empresas Médias',
  'Intermediate Term Government Bond': 'Título do Governo de Prazo Intermediário',
  'Intermediate Term US Government Bond': 'Título do Governo dos EUA de Prazo Intermediário',
  'Small Cap Value': 'Valor de Pequenas Empresas',
  'Municipal Connecticut': 'Municipal de Connecticut',
  'Municipal Alabama': 'Municipal do Alabama',
  'Intermediate Term Diversified Sectoral Bond':
    'Título Setorial Diversificado de Prazo Intermediário',
  'Long Term Low Quality': 'Longo Prazo de Baixa Qualidade',
  'Emerging Markets Bond': 'Título de Mercados Emergentes',
  'Municipal Massachusetts': 'Municipal de Massachusetts',
  'Investment Grade Government Bond': 'Título do Governo de Grau de Investimento',
  'Large Cap Value': 'Valor de Grandes Empresas',
  'Target Date': 'Data Alvo',
  'Municipal Idaho': 'Municipal de Idaho',
};

const sectors = {
  Athletics: 'Atletismo',
  Communications: 'Comunicações',
  'Consumer Discretionary': 'Consumo Discricionário',
  'Consumer Staples': 'Bens de Consumo Básico',
  Defense: 'Defesa',
  Energy: 'Energia',
  'Fashion Forward': 'Moda',
  Finance: 'Finanças',
  'Fixed Income (Bonds)': 'Renda Fixa (Títulos)',
  Grub: 'Alimentação',
  'Health Care': 'Saúde',
  Indexed: 'Indexados',
  Industrial: 'Industrial',
  Leisure: 'Lazer',
  'Pot-Folio': 'Portfólio de Cannabis',
  'Real Estate': 'Imobiliário',
  Renewables: 'Energias Renováveis',
  Tech: 'Tecnologia',
  'Short The Market': 'Operar Vendido no Mercado',
};

export default {
  fundCategories,
  investmentStyles,
  sectors,
};
